'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _editVehicleTraderTemplate = require('./editVehicleTraderTemplate.html');

var _editVehicleTraderTemplate2 = _interopRequireDefault(_editVehicleTraderTemplate);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleTradersContainerController = function () {
  function VehicleTradersContainerController(enums, $stateParams, loadingService, vehicleTraderManagementService, $uibModal, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, VehicleTradersContainerController);
    this.enums = enums;
    this.$stateParams = $stateParams;
    this.loadingService = loadingService;
    this.vehicleTraderManagementService = vehicleTraderManagementService;
    this.$uibModal = $uibModal;
    this.$scope = $scope;

    this.vehicleTraders = [];
    this.loadVehicleTraders();

    this.state = '';
    this.resetNotification();
  }

  (0, _createClass3.default)(VehicleTradersContainerController, [{
    key: 'resetNotification',
    value: function resetNotification() {
      this.notification = {
        type: '',
        msg: ''
      };
    }
  }, {
    key: 'loadVehicleTraders',
    value: function loadVehicleTraders() {
      var ctrl = this;

      ctrl.loadingService.showLoading('vehicleTradersList', 'Loading Traders ...');

      ctrl.vehicleTraderManagementService.list(ctrl.$stateParams.locationId).then(function (response) {
        ctrl.vehicleTraders = response.data.items;;
      }).finally(function () {
        ctrl.loadingService.hideLoading('vehicleTradersList');
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.$uibModalInstance.close();
    }
  }, {
    key: 'showAdd',
    value: function showAdd() {
      this.$scope.closeModal = this.closeModal.bind(this);
      this.$scope.editVehicleTrader = this.editVehicleTrader.bind(this);
      this.$scope.vehicleTrader = { entityId: this.$stateParams.locationId };
      this.$scope.editVehicleTraderMsg = '';

      this.$uibModalInstance = this.$uibModal.open({
        template: _editVehicleTraderTemplate2.default,
        scope: this.$scope
      });
    }
  }, {
    key: 'showEdit',
    value: function showEdit(vehicleTrader) {
      this.$scope.closeModal = this.closeModal.bind(this);
      this.$scope.editVehicleTrader = this.editVehicleTrader.bind(this);
      this.$scope.vehicleTrader = (0, _assign2.default)({}, vehicleTrader);
      this.$scope.editVehicleTraderMsg = '';

      this.$uibModalInstance = this.$uibModal.open({
        template: _editVehicleTraderTemplate2.default,
        scope: this.$scope
      });
    }
  }, {
    key: 'editVehicleTrader',
    value: function editVehicleTrader() {
      var ctrl = this;

      if (!this.$scope.vehicleTrader.vehicleTraderId) {

        if (!this.validateForm()) {
          return;
        }

        ctrl.loadingService.showLoading('vehicleTradersList', 'Saving Changes ...');

        ctrl.vehicleTraderManagementService.add(ctrl.$stateParams.locationId, this.$scope.vehicleTrader).then(function (response) {
          var vehicleTrader = (0, _assign2.default)({}, ctrl.$scope.vehicleTrader);
          vehicleTrader.vehicleTraderId = response.data;

          ctrl.vehicleTraders.push(vehicleTrader);
          ctrl.closeModal();
        }).finally(function () {
          ctrl.loadingService.hideLoading('vehicleTradersList');
        });
      } else {
        if (!this.validateForm()) {
          return;
        }

        ctrl.loadingService.showLoading('vehicleTradersList', 'Saving Changes ...');

        ctrl.vehicleTraderManagementService.edit(this.$scope.vehicleTrader).then(function (response) {
          var vehicleTraderList = (0, _lodash.find)(ctrl.vehicleTraders, function (o) {
            return o.vehicleTraderId === ctrl.$scope.vehicleTrader.vehicleTraderId;
          });
          (0, _assign2.default)(vehicleTraderList, ctrl.$scope.vehicleTrader);

          ctrl.closeModal();
        }).finally(function () {
          ctrl.loadingService.hideLoading('vehicleTradersList');
        });
      }
    }
  }, {
    key: 'validateForm',
    value: function validateForm() {
      var _this = this;

      this.$scope.editVehicleTraderMsg = '';

      if (!this.$scope.vehicleTrader.name) {
        this.$scope.editVehicleTraderMsg = 'Please enter a name for Vehicle Trader';
        return false;
      }

      if (this.$scope.vehicleTrader) {
        var dup = (0, _lodash.find)(this.vehicleTraders, function (o) {
          return o.name.toLowerCase() === _this.$scope.vehicleTrader.name.toLowerCase() && o.vehicleTraderId !== _this.$scope.vehicleTrader.vehicleTraderId;
        });
        if (dup) {
          this.$scope.editVehicleTraderMsg = 'A trader with the same name already exists';
          return false;
        }
      } else {
        var _dup = (0, _lodash.find)(this.vehicleTraders, function (o) {
          return o.name.toLowerCase() === _this.$scope.vehicleTrader.name.toLowerCase();
        });
        if (_dup) {
          this.$scope.editVehicleTraderMsg = 'A trader with the same name already exists';
          return false;
        }
      }

      if (this.$scope.vehicleTrader.email && !this.validateEmail(this.$scope.vehicleTrader.email)) {
        this.$scope.editVehicleTraderMsg = 'Please enter a valid emaill address for Vehicle Trader';
        return false;
      }

      return true;
    }
  }, {
    key: 'removeVehicleTrader',
    value: function removeVehicleTrader(vehicleTrader) {
      var ctrl = this;

      var sure = window.confirm("Are you sure you want to delete this Vehicle Trader ?");

      if (!sure) {
        return;
      }

      ctrl.loadingService.showLoading('vehicleTradersList', 'Removing Trader ...');

      ctrl.vehicleTraderManagementService.updateState(ctrl.$stateParams.locationId, vehicleTrader.vehicleTraderId, ctrl.enums.OBJECT_ROW_STATE.Deleted).finally(function () {
        ctrl.vehicleTraders = (0, _lodash.without)(ctrl.vehicleTraders, vehicleTrader);
        ctrl.loadingService.hideLoading('vehicleTradersList');
      });
    }
  }, {
    key: 'validateEmail',
    value: function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }]);
  return VehicleTradersContainerController;
}();

exports.default = VehicleTradersContainerController;


// WEBPACK FOOTER //
// ./client/app/components/admin/vehicleTradersManagement/vehicleTradersContainer/vehicleTradersContainer.controller.js